<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Очередь осмотров</h1>
      </v-col>

      <v-col align="right">
        <modal depressed icon="add" title="Добавить осмотр" name="Осмотр" component="add-inspection"></modal>
      </v-col>
    </v-row>
    <patient-header />
    <iframe
      class="inspection-iframe"
      :src="`${VUE_APP_V3_HOST}/inspections?hash=${hash}&customerId=${customerId}&content-only=true`"
      width="100%"
      height="500"
      allow-same-origin
      frameborder="0"
    ></iframe>
  </v-container>
</template>

<script>
import List from "./components/List";
import Modal from "@/components/Modal";
import "@/plugins/crypto-pro-loader.js";
import PatientHeader from "@/components/PatientHeader";
import { VUE_APP_V3_HOST } from "@/config";

export default {
  components: {
    List,
    Modal,
    PatientHeader,
  },
  data: () => ({
    VUE_APP_V3_HOST,
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
    hash() {
      return this.$store.state.auth.accessToken;
    },
  },

  async created() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      //get data
      //   try {
      //     const r = await this.$http.get(`v1/customers/${this.customerId}/interview-results`).then(r => r.data);
      //     if (r.success) {
      //       this.items = r.data;
      //     }
      //   } catch (e) {
      //     // TODO: Обработать ошибку
      //     console.error(e);
      //   }
      this.loading = false;
    },
  },
};
</script>
<style>
.inspection-iframe {
  height: calc(100vh - 250px);
}
</style>
